<template>
    <div class="exp-cell" v-if="params.data && params.data.experience != null">
    <span>Experience - {{params.data.experience > 0 ? params.data.experience + " yrs" : "Fresher"}}</span>
    <span v-if="params.data.internship">Internship - {{params.data.internship}}</span>
    <span v-if="params.data.internship">Duration - {{params.data.internshipduration}}}</span>
    </div>
</template>